import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Modal from 'components/Shared/Modals';
import Button from 'components/Shared/Common/Button';
import styled from 'styled-components';
import { rgba } from 'polished';

const StyledQuote = styled.div`
    color: ${({ theme }) => theme.black};
    font-size: 14px;
    font-weight: 400;
    border: 1px solid ${({ theme }) => rgba(theme.black, 0.1)};
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    padding: 10px;
    width: 100%;
    word-break: break-word;
`;

const formatMessages = intl => () => ({
    modalTitle: intl.formatMessage({
        id: 'modal.deleteFeedItem.title',
        defaultMessage: 'Supprimer votre message'
    }),
    modalContent: intl.formatMessage({
        id: 'modal.deleteFeedItem.content',
        defaultMessage: 'Voulez-vous vraiment supprimer ce message ? Cette opération est irréversible.'
    }),
    buttonCancel: intl.formatMessage({
        id: 'global.button.cancel',
        defaultMessage: 'Annuler'
    }),
    buttonValid: intl.formatMessage({
        id: 'global.button.confirm',
        defaultMessage: 'Confirmer'
    })
});

const MessageQuote = ({ label, content}) => (
    <>
        <p>
            {label}
        </p>
        {!!content && (
            <StyledQuote className="message">
                {content}
            </StyledQuote>
        )}
    </>
)

class DeleteFeedItem extends PureComponent {
    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown, false);        
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleSubmit = (e) => {
        this.props.onSubmit(this.props._feed, this.props._feedItem);
        this.props.onClose(e);
    }

    handleKeyDown = (e) => {          
        const {keyCode} = e;
        if (keyCode === 13) {
            this.handleSubmit(e);
        }
    }

    render() {
        const { intl, onClose, content } = this.props;
        const i18n = formatMessages(intl)();

        return (
            <Modal
                isOpen
                title={i18n.modalTitle}
                footer={(
                    <>
                        <Button
                            color="secondary"
                            onClick={onClose}
                        >
                            {i18n.buttonCancel}
                        </Button>
                        <Button
                            color="danger"
                            onClick={this.handleSubmit}
                        >
                            {i18n.buttonValid}
                        </Button>
                    </>
                )}
                onClose={onClose}
            >
                <MessageQuote label={i18n.modalContent} content={content} />
            </Modal>
        );
    }
}

DeleteFeedItem.propTypes = {
    intl: PropTypes.any.isRequired,
    content: PropTypes.string,
    _feed: PropTypes.string.isRequired,
    _feedItem: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

DeleteFeedItem.defaultProps = {
    content: null
};

export default injectIntl(DeleteFeedItem);
